import { IAction, ISpamPostsState } from 'types/redux'
import * as actions from 'actions/spamPostActions'
import * as postActions from 'actions/postActions'

const initialState: ISpamPostsState = {
  hasMore: false,
  pageToken: '',
  postsCount: 0,
  items: [],
  isLoading: false,
  error: null,
}

const spamPostsReducer = (state: ISpamPostsState = initialState, action: IAction): ISpamPostsState => {
  switch (action.type) {
    case actions.GET_SPAM_POSTS_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      }
    case actions.GET_SPAM_POSTS_SUCCESS: {
      const {
        hasMore,
        pageToken,
        postsCount,
        posts
      } = action.data

      return {
        ...state,
        hasMore,
        pageToken,
        postsCount,
        isLoading: false,
        items: [...state.items, ...posts]
      }
    }
    case actions.GET_SPAM_POSTS_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.error
      }
    case actions.UPDATE_SPAM_POST_STATUS_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null
      }
    case actions.UPDATE_SPAM_POST_STATUS_SUCCESS: {
      const updatedPost = action.data?.post ?? action.data

      return {
        ...state,
        isLoading: false,
        items: state.items.filter(item => item.id !== updatedPost?.id)
      }
    }
    case actions.UPDATE_SPAM_POST_STATUS_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.error
      }
    case postActions.DELETE_POST_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null
      }
    case postActions.DELETE_POST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        items: state.items.filter((x) => x.id !== action.data)
      }
    case postActions.DELETE_POST_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.error
      }
    default:
      return state
  }
}

export default spamPostsReducer
